import { render, staticRenderFns } from "./updateReleaseStatusDialog.vue?vue&type=template&id=a0d9a850&"
import script from "./updateReleaseStatusDialog.vue?vue&type=script&lang=js&"
export * from "./updateReleaseStatusDialog.vue?vue&type=script&lang=js&"
import style0 from "./updateReleaseStatusDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports